import { gql } from 'apollo-boost';

const GET_USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      tel
      stripe
      address {
        id
        unit
        street
        city
        province
      }
      bookings {
        id
        date
        bookingStatus
      }
      relationships {
        id
        relationship
        child {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export default GET_USER;